export const FiscalYearStates = {
  FUTURE: 'FUTURE',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
}
